// extracted by mini-css-extract-plugin
export default {"label":"Input_label__V2HN7","input":"Input_input__dqgp6","error":"Input_error__pF1V4"};